export const MODAL_SET_ON_HOLD_DOWN_TEXT = {
	confirmBtn: 'Confirm',
	setOnHoldDownTitle: 'Add hold down',
	setOnHoldDownDescription: 'Please select a time frame and the driver for replacement',
	cancelBtn: 'Cancel',
	startDateAndTime: 'Start date and time',
	startTimeAriaLabel: 'Start time',
	endDateAndTime: 'End date and time',
	endTimeAriaLabel: 'End time',
	endTimePlaceholder: 'hh:mm',
	noteLabel: 'Note',
	notePlaceholder: 'Additional information',
};
